import { Form, Table } from "antd";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getToilData } from "../../redux/rtk/features/overtime/overtimeSlice";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");

function GetToil() {
    const dispatch = useDispatch();
    const { toilData, loading } = useSelector((state) => state.overtime);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [form] = Form.useForm();

    console.log("toilData", toilData);

    useEffect(() => {
        dispatch(getToilData());
    }, [dispatch]);

    const formatOvertimeLength = (length) => {
        const hours = Math.floor(length);
        const minutes = Math.round((length - hours) * 60);
        return `${hours}h ${minutes}m`;
    };

    const columns = [
        {
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
        },
        {
            title: "Toil Taken Date",
            dataIndex: "toilTakenDate",
            key: "toilTakenDate",
            render: (toilTakenDate) => dayjs(toilTakenDate).utc().format("DD-MM-YYYY, HH:mm A"),
        },
        {
            title: "Toil Taken",
            dataIndex: "toilTaken",
            key: "toilTaken",
            render: (toilTaken) => formatOvertimeLength(toilTaken),
        },
        {
            title: "Toil Balance",
            dataIndex: "toilBalance",
            key: "toilBalance",
            render: (toilBalance) => formatOvertimeLength(toilBalance),
        },
        
    ];

    const handleAction = (record) => {
        setSelectedRecord(record);
        form.setFieldsValue({
            user: `${record.user.firstName} ${record.user.lastName}`,
            overtimeHours: record.overtimeLength,
            overtimeStatus: record.status ? "Approved" : "Pending",
        });
        setIsModalVisible(true);
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
        setSelectedRecord(null);
        form.resetFields();
    };

    const handleModalSubmit = async () => {
        try {
            const values = await form.validateFields();
            // Submit logic (e.g., update data via an API call)
            toast.success("Overtime data updated successfully!");
            setIsModalVisible(false);
            form.resetFields();
        } catch (info) {
            console.error("Validation Failed:", info);
        }
    };

    // Access toilData.data (the actual array) instead of toilData directly
    const dataSource = (toilData?.data || []).map((item, index) => ({
        ...item,
        serial: index + 1,
    }));

    return (
        <div>
            {/* Display a loading message or no data available message */}
            {loading && <div>Loading...</div>}
            {!loading && (!toilData || toilData.data.length === 0) && <div>No data available</div>}
            
            <Table
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                rowKey="id"
            />
            
            
        </div>
    );
}

export default GetToil;
